<script>
  import { globalComputed } from "@store/helpers";
  import TheHeader from './TheHeader'
  import TheFooter from './TheFooter'
  import _throttle from 'lodash/throttle'
  export default {
    components: { TheHeader, TheFooter },
    data() {
      return {
        scrollTop: 0,
        onScroll: _throttle(() => {
          this.scrollTop = this.getWindowScrollTop()
        }, 200),
      }
    },
    computed: {
      ...globalComputed,
    },
    created() {
    },
    mounted() {
      window.addEventListener('scroll', this.onScroll)
    },
    destroyed() {
      window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
      scrollToTop() {
        const c = document.documentElement.scrollTop || document.body.scrollTop
        if(c > 0) {
          window.requestAnimationFrame(this.scrollToTop)
          window.scrollTo(0, c - c / 8)
        }
      },
      getWindowScrollTop() {
        let windowScrollTop = 0
        if(typeof window.pageYOffset !== 'undefined') {
          windowScrollTop = window.pageYOffset
        } else if(typeof document.compatMode !== 'undefined' && document.compatMode !== 'BackCompat') {
          windowScrollTop = document.documentElement.scrollTop
        } else if(typeof document.body !== 'undefined') {
          windowScrollTop = document.body.scrollTop
        }
        return windowScrollTop
      },
      onMobileMenuOpen(val) {
        this.$emit('mobileOpen', val)
      }
    },
  }
</script>

<template>
  <div :class="[$style.layout]">
    <TheHeader />
    <slot/>
    <TheFooter />
    <BaseButton
      :class="[$style.scrollToTop, { [$style.isHidden]: scrollTop < 500 }, { [$style.isFbFanpageId]: !!currentSetting['fb_fanpage_id'] }]"
      class="isStyleWhite isCircle d-md-block d-none"
      @click="scrollToTop">
      <i class="fal fa-chevron-up"></i>
    </BaseButton>
    <BaseButton
      :class="[$style.scrollToTop, $style.contact,  { [$style.isHidden]: scrollTop < 500 }, { [$style.isFbFanpageId]: !!currentSetting['fb_fanpage_id'] }]"
      class="isStyleWhite isRadius"
      target="_blank"
      :href="$globalContactLink"
    >
      與我聯繫
    </BaseButton>
  </div>
</template>
<style lang="scss" module>
  .layout {
    :global {

    }
  }

  .scrollToTop {
    position: fixed;
    right: 25px;
    bottom: 15rem;
    z-index: 99;
    width: 60px !important;
    height: 36px !important;
    font-size: 1rem;
    border-radius: 7px !important;
    opacity: 1;
    transition: all 0.3s !important;
    border: 1px solid $color-primary !important;
    visibility: visible ;
    &:hover {
      color: #FFF !important;
      // background: none;
      background-color: $color-primary !important;
      // border-color: $color-primary !important;
    }

    &.isHidden {
      opacity: 0;
      visibility: hidden;
    }
    &.contact {
      bottom: 5.5rem;
      writing-mode: vertical-lr;
      border: 0 !important;
      height: 132px !important;
      box-shadow: 0px 10px 15px #00000029;
      letter-spacing: 0.2em;
      @include max-lg {
        padding: 0.8rem 1.3rem;
      }
      &.isFbFanpageId {
        bottom: 12.5rem;
      }
    }
    &.isFbFanpageId {
      bottom: 22.5rem;
    }
  }
</style>
